import React, {useState, useEffect, useContext} from 'react';
import {
  Box,
  Toolbar,
  Typography,
  Container,
  Paper,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  IconButton,
} from '@mui/material';
import Title from '../../components/Common/Title';
import {HeadsetRounded} from '@mui/icons-material';
import {Context as AuthContext} from '../../contexts/AuthContext';
import {Context as FinancialContext} from '../../contexts/FinancialContext';

const headerStyle = {
  color: '#9d9db0',
  fontSize: 18,
  fontWeight: 700,
  letterSpacing: '1.6px',
  lineHeight: '24px',
  textTransform: 'uppercase',
  alignSelf: 'flex-start',
};

const Goals = ({}) => {
  const {
    state: {uid, client, financial},
  } = useContext(AuthContext);
  const {
    state: {accounts, transactions},
  } = useContext(FinancialContext);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: '#fff',
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        padding: '60px',
      }}>
      <Container maxWidth="lg" sx={{mt: 4, mb: 4}}>
        <Grid container spacing={3}>
          <Card header="Budget" subheader="See your..." />
          <Card header="Savings" subheader="See your..." />
          <Card header="Investing" subheader="See your..." />
          <Card header="Credit" subheader="See your..." />
        </Grid>
      </Container>
    </Box>
  );
};

const findBalanceByAccount = account => {
  const {balances, accountType} = account;
  switch (accountType) {
    case 'credit':
    case 'debt':
      return -1 * balances.current;
    case 'investment':
      if (
        balances.current !== null &&
        balances.available !== null &&
        balances.current.toFixed(2) !== balances.available.toFixed(2)
      ) {
        return balances.current + balances.available;
      } else if (balances.available !== null) {
        return balances.available;
      } else {
        return balances.current;
      }
    default:
      return balances.available !== null
        ? balances.available
        : balances.current;
  }
};

const Account = ({item}) => {
  return (
    <Grid item xs={6} md={6} lg={6}>
      <Paper
        sx={[
          {
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            padding: '48px 64px',
            borderRadius: '12px',
            alignItems: 'center',
          },
        ]}
        elevation={24}>
        <Typography component="p" variant="h6">
          {item.official_name ? item.official_name : item.name}
        </Typography>
        <Typography>${findBalanceByAccount(item).toFixed(2)}</Typography>
        <Typography>{item.type}</Typography>
      </Paper>
    </Grid>
  );
};

const Card = ({header, subheader, onClick}) => {
  return (
    <Grid item xs={6} md={6} lg={6}>
      <Paper
        sx={[
          {
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            padding: '48px 64px',
            borderRadius: '12px',
            alignItems: 'center',
          },
        ]}
        elevation={24}>
        <Typography
          component="h2"
          variant="h6"
          color="primary"
          gutterBottom
          style={headerStyle}>
          {header}
        </Typography>
        <Typography
          color="text.secondary"
          sx={{flex: 1}}
          style={{alignSelf: 'flex-start'}}>
          {subheader}
        </Typography>
      </Paper>
    </Grid>
  );
};

export default Goals;
